// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-title {\n  background-color: #2f63af;\n  display: table;\n  height: 80px;\n  width: 100%;\n  margin-top: 0;\n}\n.main-title h1 {\n  color: white;\n  display: table-cell;\n  vertical-align: middle;\n  font-size: 26pt;\n  line-height: 26pt;\n}\n.navigation .v-toolbar__content {\n  padding-left: 0px;\n}\n.v-chip.v-size--default {\n  height: unset !important;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n.half {\n  max-width: 50%;\n}", ""]);
// Exports
module.exports = exports;
